import { Component, OnInit } from '@angular/core';
import Keycloak from 'keycloak-js';
import { UserInfoService } from '../../services/security/user-info.service';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-menu-profil',
  templateUrl: './menu-profil.component.html',
  styleUrls: ['./menu-profil.component.scss'],
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, NgIf]
})
export class MenuProfilComponent implements OnInit {
  constructor(
    private readonly keycloak: Keycloak,
    private readonly userInfoService: UserInfoService
  ) {}

  ngOnInit(): void {}

  public logout(): void {
    this.keycloak.logout();
  }

  goToParameter(): void {
    window.location.href = 'utilisateur/parametre';
  }

  goToAdministration(): void {
    window.location.href = 'configuration';
  }

  goToReleaseNotes(): void {
    window.location.href = 'configuration/notes-de-version';
  }

  goToGlobalSettings(): void {
    window.location.href = 'configuration/global-settings';
  }

  isAdmin(): boolean {
    return this.userInfoService.isAdministrateur();
  }
}
